import { useCompleteFragment } from '@eluve/apollo-client';

import { useAppointmentId } from './appointment.context';
import { appointmentNameFragment } from './operations';

export const useAppointmentName = () => {
  const appointmentId = useAppointmentId();

  const data = useCompleteFragment({
    fragment: appointmentNameFragment,
    key: {
      id: appointmentId,
    },
    strict: false,
  });

  return data?.name ?? '';
};
